/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Tenant_Access_DeniedInputs */

const nl_auth_api_errors_tenant_access_denied = /** @type {(inputs: Auth_Api_Errors_Tenant_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt geen toegang tot deze school`)
};

/**

* @param {Auth_Api_Errors_Tenant_Access_DeniedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_tenant_access_denied = /** @type {((inputs?: Auth_Api_Errors_Tenant_Access_DeniedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Tenant_Access_DeniedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_tenant_access_denied(inputs)
});
export { auth_api_errors_tenant_access_denied as "auth.api_errors.tenant_access_denied" }